import React from 'react';
import { useTranslation } from 'react-i18next';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import {
  ButtonContainer,
  HeaderContainer,
  ScrollButton,
  Spacer,
} from './index.style';

const Header = ({
  isMobile,
  handleScrollLeft,
  handleScrollRight,
  canScrollLeft,
  canScrollRight,
}) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      {!isMobile && <Spacer />}
      {t('comparePackages')}
      {!isMobile && (canScrollLeft || canScrollRight) ? (
        <ButtonContainer>
          <ScrollButton
            type="button"
            onClick={handleScrollLeft}
            disabled={!canScrollLeft}
          >
            <ArrowBackRoundedIcon
              sx={{ fontSize: '24px', color: '#1E164ECC' }}
            />
          </ScrollButton>
          <ScrollButton
            type="button"
            onClick={handleScrollRight}
            disabled={!canScrollRight}
          >
            <ArrowForwardRoundedIcon
              sx={{ fontSize: '24px', color: '#1E164ECC' }}
            />
          </ScrollButton>
        </ButtonContainer>
      ) : (
        <div />
      )}
    </HeaderContainer>
  );
};

export default Header;
